module.exports = __webpack_public_path__ + "img/default.45f4252e.svg";